import { Skeleton } from "antd"
import { useContext } from "react"
import { CompletedWorkareaVisit } from "../../../domain/invoicing/invoicingApi"
import { useInvoiceSummariesForJobQuery, useTransactionsForJobQuery } from "../../../domain/invoicing/invoicingQueries"
import { WorkareaGroupWithWorkareas } from "../../../domain/workareas/group"
import { WorkareaSummary } from "../../Items/itemSummaryModel"
import WorkareaTotals from "./WorkareaTotals"
import { buildWorkareaGroupInvoiceTotals, calculateInvoiceTotals } from "./workareaTotalsModel"
import InvoiceTotalStatistics from "./InvoiceTotalStatistics"
import SectionCard, { SectionLayoutContext } from "../../common/SectionCard"

type Props = {
  jobId: number
  workareaGroups: WorkareaGroupWithWorkareas[]
  workareaSummaries: WorkareaSummary[]
  completedWorkareaVisits: CompletedWorkareaVisit[]
}

const InvoiceTotals = ({ jobId, workareaGroups, workareaSummaries, completedWorkareaVisits }: Props) => {
  const layout = useContext(SectionLayoutContext)
  const transactionsQuery = useTransactionsForJobQuery(jobId)
  const invoiceSummariesQuery = useInvoiceSummariesForJobQuery(jobId)

  if (transactionsQuery.isLoading || invoiceSummariesQuery.isLoading) {
    return <Skeleton active />
  }

  const groupTotals = buildWorkareaGroupInvoiceTotals(workareaGroups, workareaSummaries, completedWorkareaVisits, transactionsQuery.data ?? [])
  const invoiceTotals = calculateInvoiceTotals(groupTotals, invoiceSummariesQuery.data ?? [])

  if (layout === 'card') {
    return <>
      <InvoiceTotalStatistics
        invoiceTotals={invoiceTotals}
      />
      <SectionCard title="Workarea Totals">
        <WorkareaTotals
          groupTotals={groupTotals}
          invoiceTotals={invoiceTotals}
        />
      </SectionCard>
    </>
  }

  return <>
    <SectionCard title="Workarea Totals">
      <WorkareaTotals
        groupTotals={groupTotals}
        invoiceTotals={invoiceTotals}
      />
    </SectionCard>
    <section>
      <InvoiceTotalStatistics
        invoiceTotals={invoiceTotals}
      />
    </section>
  </>
}

export default InvoiceTotals
